import React, { useState } from "react";
import { X, Settings } from "lucide-react";
import { getWalmartFeeSettings, saveWalmartFeeSettings } from "../../utils/walmartFees";

const WalmartFeeSettingsModal = ({ onClose }) => {
    const [settings, setSettings] = useState(() => getWalmartFeeSettings());

    const update = (key, value) => setSettings((s) => ({ ...s, [key]: value }));

    const handleSave = () => {
        saveWalmartFeeSettings(settings);
        onClose(settings);
    };

    return (
        <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4" onClick={() => onClose(null)}>
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm overflow-hidden" onClick={(e) => e.stopPropagation()}>
                <div className="bg-gradient-to-r from-teal-500 to-blue-600 px-6 py-4 flex items-center justify-between">
                    <h2 className="text-white font-bold text-lg flex items-center gap-2">
                        <Settings size={18} /> Walmart Fee Settings
                    </h2>
                    <button onClick={() => onClose(null)} className="text-white/70 hover:text-white"><X size={20} /></button>
                </div>
                <div className="p-6 space-y-4">
                    <div>
                        <label className="text-xs font-semibold text-gray-600 mb-1 block">Sales Tax (%)</label>
                        <input type="number" step="0.1" value={settings.salesTax || ""}
                            onChange={(e) => update("salesTax", e.target.value)}
                            className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-teal-500" />
                    </div>
                    <div>
                        <label className="text-xs font-semibold text-gray-600 mb-1 block">Inbound Shipping ($/lb) — WFS only</label>
                        <input type="number" step="0.01" value={settings.inboundShipping || ""}
                            onChange={(e) => update("inboundShipping", e.target.value)}
                            className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-teal-500" />
                    </div>
                    <div>
                        <label className="text-xs font-semibold text-gray-600 mb-1 block">Fulfillment Cost ($) — SF only</label>
                        <input type="number" step="0.01" value={settings.fulfillmentCost || ""}
                            onChange={(e) => update("fulfillmentCost", e.target.value)}
                            className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-teal-500" />
                        <p className="text-[10px] text-gray-400 mt-1">Your own shipping/handling cost when not using WFS.</p>
                    </div>
                    <button onClick={handleSave}
                        className="w-full py-3 bg-gradient-to-r from-teal-500 to-blue-600 text-white rounded-xl font-bold hover:opacity-90 transition">
                        Save Settings
                    </button>
                </div>
            </div>
        </div>
    );
};

export default WalmartFeeSettingsModal;